module.exports = __webpack_public_path__ + "img/26.ed0f002b.jpg";